import React from "react";
import PropTypes from "prop-types";

import { ratingToClass } from "../../util/programPerformance";

/**
 * Contract Holder Program Performance Table Row Component
 * @param {Object} props
 * @param {ContractHolderPerformanceRating} chPerformance
 * @returns {Element}
 * @constructor
 */
export default function TableRow({ chPerformance }) {
  return (<tr className="ch-pp-row">
    <td title={chPerformance.displayName} className="ch-name">{chPerformance.contractHolder}</td>
    <td className={ratingToClass(chPerformance.reports)}>{chPerformance.reports}</td>
    <td className={ratingToClass(chPerformance.customerSatisfaction)}>{chPerformance.customerSatisfaction}</td>
    <td
      className={ratingToClass(chPerformance.informationDistribution)}>{chPerformance.informationDistribution}</td>
    <td className={ratingToClass(chPerformance.constractAdherence)}>{chPerformance.constractAdherence}</td>
    <td className={ratingToClass(chPerformance.delivery)}>{chPerformance.delivery}</td>
  </tr>);
}

TableRow.propTypes = {
  chPerformance: PropTypes.object.isRequired
};